import React from "react";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Typography, IconButton } from "@material-ui/core";
import Button from "jb_component_library/components/Button";
import { modalBaseProps } from "./ModalBase.d";
import useModalBaseStyles from "./ModalBaseStyles";
import CloseIcon from "@mui/icons-material/Close";
import Grids from "jb_component_library/components/Grid";

const ModalBase: React.FC<modalBaseProps> = (props) => {
	const classes = useModalBaseStyles({ maxWidth: props.maxWidth });
	const {
		open,
		onClose: handleClose,
		title,
		primaryButtonProps,
		secondaryButtonProps,
		textButtonProps: textButton,
		children,
	} = props;

	return (
		<div>
			<Dialog
				open={open}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				maxWidth="xs"
				classes={{ paper: classes.root }}
			>
				<DialogTitle className={classes.title} id="alert-dialog-title">
					<Box display="flex">
						<Box p={1} width="100%">
							<Typography variant="h3">{title}</Typography>
						</Box>
						{handleClose && (
							<Box p={1} className={classes.iconBox}>
								<IconButton onClick={handleClose} className={classes.iconBox}>
									<CloseIcon fontSize="large" className={classes.icon} />
								</IconButton>
							</Box>
						)}
					</Box>
				</DialogTitle>
				<DialogContent className={classes.content}>{children}</DialogContent>
				<DialogActions className={classes.actions}>
					<Grids container direction="row-reverse" gutter="narrow">
						{primaryButtonProps && (
							<Grids item className={classes.gridItem}>
								<Button
									label={primaryButtonProps.text}
									type="action"
									onClick={primaryButtonProps.onClick}
									fullWidth={false}
								/>
							</Grids>
						)}
						{secondaryButtonProps && (
							<Grids item className={classes.gridItem}>
								<Button
									label={secondaryButtonProps.text}
									type="secondary"
									onClick={secondaryButtonProps.onClick}
									fullWidth={false}
								/>
							</Grids>
						)}
						{textButton && (
							<Grids item className={classes.gridItem}>
								<Button
									label={textButton.text}
									type="secondary"
									onClick={textButton.onClick}
									fullWidth={false}
									customStyles={{
										textDecoration: "underline",
										border: "0px",
										boxShadow: "0 0 0 0",
									}}
								/>
							</Grids>
						)}
					</Grids>
				</DialogActions>
			</Dialog>
		</div>
	);
};
export default ModalBase;
